import { render, staticRenderFns } from "./CreateGlobalAlert.vue?vue&type=template&id=1e289f97&"
import script from "./CreateGlobalAlert.vue?vue&type=script&lang=js&"
export * from "./CreateGlobalAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e289f97')) {
      api.createRecord('1e289f97', component.options)
    } else {
      api.reload('1e289f97', component.options)
    }
    module.hot.accept("./CreateGlobalAlert.vue?vue&type=template&id=1e289f97&", function () {
      api.rerender('1e289f97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/CreateGlobalAlert.vue"
export default component.exports